import React from "react";
import AppHeader from "../components/Header";
import { Box, Container, Grid, Stack, styled } from "@mui/material";
import AppConfig from "./config";
import Loader from "../common/Loader";
import AppFooter from "../components/CustomPages/Footer";
import { useDomainConfig } from "./domainConfigProvider";
import SocialIcons from "../components/SocialIcons";

const Image = styled("img")(() => ({
  width: "100%",
  height: "calc(100vh - 64px)",
  objectFit: "cover",
}));

const RouterContext = React.createContext({
  location: "",
  navigate: () => { },
  state: null,
});

export function Router(props) {
  const [location, setLocation] = React.useState(window.location.pathname);
  const [state, setState] = React.useState(null);

  React.useEffect(() => {
    const onPopState = (event) => {
      setLocation(window.location.pathname);
      if (event.state) {
        setState(event.state);
      } else {
        setState(null);
      }
    };

    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  const navigate = (to,navigationState = null) => {
    window.history.pushState(navigationState, "", to);
    setLocation(to);
    setState(navigationState);
  };

  return (
    <RouterContext.Provider value={{ location, navigate, state }}>
      {props.children}
    </RouterContext.Provider>
  );
}

export function useNavigate() {
  return React.useContext(RouterContext);
}

export function useLocation() {
  return React.useContext(RouterContext).location;
}

export function useLocationState() {
  return React.useContext(RouterContext).state;
}


export function useQueryParams() {
  return React.useContext(RouterContext).queryParams;
}

export function Route(props) {
  const { domainConfig, loading } = useDomainConfig();

  const { location } = React.useContext(RouterContext);

  if (location !== props.path) return null;

  const hasImage = !loading && (domainConfig?.customImage || AppConfig.Banner.image);

  const isTestDomain = domainConfig?.brandUrl === AppConfig?.CustomeUI?.BrandURL;


  return (
    <>
      <AppHeader />
      <Container sx={{ minWidth: '100%' }} disableGutters>
        <Grid container spacing={0} justifyContent={location === '/items' ? 'center' : (!hasImage ? "center" : "flex-start")}>
          <Grid
            item
            xs={12}
            // md={hasImage ? (props.index || props.otp ? 4 : 6) : 6}>
            md={props.index || props.otp ? 4 : 9}>
            <Stack
              sx={{
                justifyContent: "space-between",
                height: hasImage ? "calc(100vh - 64px)" : "auto",
                px: 6,
                py: 3,
                ...(location === '/items' ? {} : {
                  overflowX: "hidden",
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#d3d3d3 #f7f7f7',
                }),
              }}
            >
              <Box sx={{ display: "flex", my: 1 }}>{props.element}</Box>
              {!isTestDomain && <SocialIcons />}
            </Stack>
          </Grid>
          {(!loading) ? (
            (hasImage && location !== '/items') && (
              <Grid
                item
                xs={12}
                sm={props.index || props.otp ? 8 : 6}
                display={{ xs: "none", md: "flex" }}
              >
                <Image
                  key="bannerImage"
                  alt="Banner Image - Prozo"
                  src={
                    domainConfig?.customImage
                      ? domainConfig.customImage
                      : AppConfig.Banner.image
                  }
                  sx={{
                    width: '100%',
                    height: 'calc(100vh - 64px)',
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                />
              </Grid>
            )
          ) : (
            <Grid item xs={12} display="flex" justifyContent="center">
              <Loader />
            </Grid>
          )}
        </Grid>
      </Container>
      {isTestDomain && <AppFooter />}
    </>
  );
}
